import { ROLE } from "../consts/constants"
import { getItem } from "../services/localStorageService"

const getRole=()=>{
    return getItem(ROLE)
}
export default getRole